import React from 'react';
import { useAppConstantsContext } from '@/context/AppConstants';
import { Button, Modal, Text, Stack } from '@/theme/components';
import { Icons } from '@/theme/index';

export const PdfAddonSuccessModal = ({
  open,
  onClose,
  printPDFAction,
  EmailPDFAction,
}: {
  open: boolean;
  onClose: () => void;
  printPDFAction: () => void;
  EmailPDFAction: () => void;
}) => {
  const {
    images: { pdfLogo },
  } = useAppConstantsContext();

  return (
    <Modal open={open} onClose={onClose}>
      <Stack justifyContent="center" direction="column" gap={2.5}>
        <Stack alignItems="center" direction="column" gap={1}>
          <img width={55} src={pdfLogo} alt="pdfLogo" />
          <Text margin={0} align="center" variant="h4">
            Success!
          </Text>
          <Text margin={0} align="center" variant="h6">
            You now have access to PDF reports!
          </Text>
        </Stack>
        <Stack direction={{ sm: 'row' }} gap={1.5}>
          <Button
            startIcon={<Icons.Print fontSize="small" />}
            variant="contained"
            onClick={printPDFAction}
            color="success"
          >
            Print PDF
          </Button>
          <Button
            startIcon={<Icons.Send fontSize="small" />}
            variant="contained"
            onClick={EmailPDFAction}
            color="success"
          >
            Email PDF
          </Button>
        </Stack>
      </Stack>
    </Modal>
  );
};
